import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import React, { useState } from 'react';
import styled from 'styled-components';
import { useRoute } from 'src/app/infra/routes';
import { postForgotPassword } from 'src/app/services/accounts';
import { BtnLoading, Msgbox } from 'src/app/shared/utils';
import { useWrapper } from 'src/utils/axios';
import { Form, Title, Wrapper } from '../login';
import { IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';

const Centered = styled.span`
  display: flex;
  justify-content: center;
  width: 100%;
  font-weight: bold;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;

  h5,
  .MuiFormControl-root {
    width: 100%;
    margin-top: 0px;
  }
`;

interface Props {
  open: boolean;
  identidadeVisual: object;
  handleClose: (done: boolean) => void;
}

export default ({ open, identidadeVisual, handleClose }: Props) => {
  const {
    params: { condominio, token }
  } = useRoute();
  const response = useWrapper();
  const [successMessage, setSuccessMessage] = useState('');
  const [disable, setDisable] = useState(false);

  const [email, setEmail] = useState('');

  const postRecuperarSenha = () => {
    response.exec(
      postForgotPassword(email, String(token + '-' + condominio)),
      () => {
        setDisable(true);
        setSuccessMessage(
          'E-mail para recuperação de senha enviado com sucesso.'
        );
        setTimeout(() => {
          cleanSection(true);
        }, 20000);
      }
    );
  };

  const cleanSection = (isTrue: boolean) => {
    setEmail('');
    setDisable(false);
    setSuccessMessage('');
    handleClose(isTrue);
  };

  return (
    <Dialog open={open} onClose={() => cleanSection(false)}>
      <Row>
        <Title variant="h5" color="primary">
          Esqueci a senha
        </Title>
        <IconButton onClick={() => cleanSection(false)}>
          <Close />
        </IconButton>
      </Row>
      <DialogContent>
        <Wrapper style={{ paddingBottom: '6px' }}>
          <Centered>
            Digite a baixo o e-mail para qual deseja redefinir a senha
          </Centered>
          <Form style={{ marginTop: '0rem', alignItems: 'center' }}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel htmlFor="email">E-mail</InputLabel>
              <OutlinedInput
                id="email"
                label="E-mail"
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </FormControl>
            <BtnLoading
              customColor
              backgroundColor={identidadeVisual?.['headerColor'] || '#083F8B'}
              disabled={!email || disable}
              loading={response.loading}
              onClick={() => {
                postRecuperarSenha();
              }}
            >
              Enviar
            </BtnLoading>
          </Form>
        </Wrapper>
      </DialogContent>
      <Msgbox error={response.error} onClose={() => response.reset()} />
      {successMessage.length ? (
        <Msgbox success={successMessage} onClose={() => handleClose(true)} />
      ) : null}
    </Dialog>
  );
};
